<template>
    <span class="w-100">
        <!-- <span class="float-right">{{currency != null && currency != "" ? " "+currency : ""}}{{ text != null && text != "" ? text : "" }}</span> -->
        <span class="">{{currency != null && currency != "" ? " "+currency : ""}}{{ text != null && text != "" ? text : "" }}</span>
    </span>
</template>
<script>

export default {
    props: {
        text : {
            default: '',
            type: String,
        },
        currency : {
            default: '',
            type: String,
        }
    }    
}
</script>